import React from 'react';
import T from 'prop-types';

import SimpleCard from '../../../../../components/Card/SimpleCard';
import UsageTrend from './UsageTrend';
import UsageTransitions from './UsageTransitions';
import SegmentConcentration from './SegmentConcentration';

const MarketBehavior = ({ isPress }) => (
  <SimpleCard
    headerLeft={
      <>
        <h3 className="h3 header-heading">AI User Segmentation</h3>
        <p className="header-description">
          Identifies key AI user types and tracks the flow of these users.
        </p>
      </>
    }
    actionsLeft={<div className="highcharts-watermark" />}
    contentDisableGutters
  >
    <UsageTrend isPress={isPress} />
    <UsageTransitions isPress={isPress} />
    <SegmentConcentration isPress={isPress} />
  </SimpleCard>
);

MarketBehavior.propTypes = {
  isPress: T.bool,
};

export default MarketBehavior;
